export default "__VITE_ASSET__CsAcZyoM__"